module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message_template":"Message template","message_template_text":"This is the message your sales team will receive from new leads."},"id":{"message_template":"Template pesanan","message_template_text":"Ini adalah pesan yang akan diterima tim penjualan kamu dari leads baru."}}')
  delete Component.options._Ctor
}
